__turbopack_context__.v({
  "isOpen": "panelControl-module-scss-module__Q2DTfa__isOpen",
  "panel": "panelControl-module-scss-module__Q2DTfa__panel",
  "panelControl": "panelControl-module-scss-module__Q2DTfa__panelControl",
});
